/* Moves Swym's own PDP wishlist button-bar onto the product image (top-right),
   matching the PLP collection-card heart placement, instead of reimplementing
   the button. Same node, same click handlers and fave-count -- just relocated. */
window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function () {
  var attempts = 0;
  var maxAttempts = 25; // ~5s at 200ms -- the widget injects async after SwymCallbacks fires
  var poll = setInterval(function () {
    attempts++;
    var bar = document.querySelector('.swym-wishlist-button-bar');
    var gallery = document.querySelector('.product-gallery');
    if (bar && gallery) {
      clearInterval(poll);
      bar.classList.add('swymcs-pdp-repositioned');
      gallery.appendChild(bar);
    } else if (attempts >= maxAttempts) {
      clearInterval(poll);
    }
  }, 200);
});
